export default (price: number | null | undefined): string =>
  price ? `$${price.toLocaleString()}` : ''
